import React from "react";
import SupplierBalanceReport from "./SupplierBalanceReport";

const SupplierAdvance = () => <SupplierBalanceReport mode="advance" />;

export default SupplierAdvance;
